import React from 'react';

import PDPImage from './pdp-image';
import { Helpers } from '../../core/src/helpers';
import NavArrow from '../../shared/components/nav-arrow';
import { Carousel, setCarouselHeight } from '../../shared/components/carousel';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import BrightCove from '../../shared/components/brightcove';
import AccessibleElement from '../../ui/components/accessible-element';

import '../css/pdp-image.less';


class PDPImageContainer extends React.PureComponent {

    static defaultProps = {
        images: []
    };

	state = { selected: 0 };

	pdpImage = [];

	controls() {
		return {
			renderCenterLeftControls : NavArrow.PrevArrow,
			renderCenterRightControls: NavArrow.NextArrow,
			renderBottomCenterControls: () => <div></div>
		}
	}

    static getDerivedStateFromProps(props, state){
        if(state.selected > (props.images.length - 1)){
            return {
                selected: 0
            };
        }
        return null;
    }

    changeImage = (num) => () => {
        if(this.state.selected != num) this.setState({selected: num});
	}
	
	handleKeyUp = (e, i) => {
		e.preventDefault();
		let charCode = e.keyCode || e.which;
		if (charCode === 39) {
			if (i + 1 < this.pdpImage.length){
				this.pdpImage[i + 1].focus();
			}
		} else if (charCode === 37) {
			if (i - 1 >= 0){
				this.pdpImage[i-1].focus()
			}
		} else if (charCode === 13){
			this.changeImage(i)();
		}
	}
	
	setPdpImageRef = (i) => (pdpImage) => {
		this.pdpImage[i] = pdpImage;
	}

    render() {
        const { images, defaultImages, sku, selectedColor } = this.props;
        const { selected } = this.state;
        let settings = {
            slidesToShow: this.props.slidesToShow || 4,
            slidesToScroll: 3,
            heightMode: 'max',
            initialSlideWidth: 98,
            initialSlideHeight: 58,
			...this.controls(),
        }
        let cdnImages = Helpers.getProductCDNImages({
            images,
            defaultImages,
            sku,
            selectedColor
        },[75,430]);
        const pdpImageProps = {
            images: cdnImages,
            selected
        };

        let selectedImage = images[selected] || {};

        return (
            <div className="pdp-image">
                { selectedImage.type !== 'video' ? <PDPImage {...pdpImageProps} /> : <BrightCove src={selectedImage.src}/> }
                <div className="pdp-image-select">
                    <Carousel enableKeyboardControls={false} {...settings} ref={carousel => this.carousel = carousel}>
                        {cdnImages.map((image, i) => {
                            let isSelected = selected == i;
							const imageSrc = image.cdnMap ? image.cdnMap.get(75) : image.lrg || image.cdn;
                            return (
								<AccessibleElement
									element="div"
									key={`${image.ordinal}-${i}`} 
									ref={this.setPdpImageRef(i)}
									className={`pdp-image-thumbnail${isSelected ? ' selected' : ''}`} 
									onClick={this.changeImage(i)}
									ariaLabel={`Product Image Number ${i}`}
									onKeyUp={(e) => {this.handleKeyUp(e, i)}}
								>
									<ImageWithPlaceholder
                                        src={imageSrc}
                                        onLoad={i === 0 ? () => setCarouselHeight(this.carousel) : null}
                                    />
								</AccessibleElement>
                            )
                        })}
                    </Carousel>
                </div>
            </div>
        )
    }
}

export default PDPImageContainer;
